
import { ConnectionService } from './connection.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResponsiveService {

    MobileBreakPoint = 800;

    constructor() {}

    isMobile () {
        if (window.innerWidth < this.MobileBreakPoint) {
            return true;
        } else {
            return false;
        }
    }

    isDesktop () {
        if (window.innerWidth > this.MobileBreakPoint) {
            return true;
        } else {
            return false;
        }
    }
}
